import { useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import '@fontsource/outfit';

import TopBarSection from './components/TopBarSection';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import DeviceManagerSection from './components/DeviceManagerSection';
import DashboardSection from './components/DashboardSection';
import FooterSection from './components/FooterSection';
import DarwinPage from './pages/DarwinPage';
import EdenPage from './pages/EdenPage';
import InstallationPage from './pages/InstallationPage';
import CustomerLandingPage from './pages/CustomerLandingPage';
import CookieBanner from './components/CookieBanner';
import FAQsPage from './pages/FAQsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

const theme = createTheme({
  palette: {
    primary: { main: '#004D40' },
    background: { default: '#ffffff' },
  },
  typography: {
    fontFamily: 'Outfit, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { fontFamily: 'Outfit, sans-serif' },
      },
    },
  },
});

function HomePage() {
  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <DeviceManagerSection />
      <DashboardSection />
      <FooterSection />
    </>
  );
}

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const params = new URLSearchParams(search);
    if (params.get('video') === '1') {
      sessionStorage.setItem('showInstallationVideo', '1');
    }
    if (params.get('link')) {
      sessionStorage.setItem('customerLink', params.get('link'));
    }
    if (params.get('company')) {
      sessionStorage.setItem('customerCompany', params.get('company'));
    }
    if (params.get('product')) {
      sessionStorage.setItem('customerProduct', params.get('product'));
    }
  }, [search]);
  return null;
}

function HomeRoute() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const isCustomer =
    params.get('link') ||
    sessionStorage.getItem('customerLink');
  return isCustomer ? <CustomerLandingPage /> : <HomePage />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <TopBarSection />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          <Route path="/darwin" element={<DarwinPage />} />
          <Route path="/eden" element={<EdenPage />} />
          <Route path="/installation" element={<InstallationPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
